import { Bridge } from '@daangn/webview-bridge-modern'
import { PluginInfo } from '@daangn/webview-bridge-modern/lib/plugins/Info'
import { PluginRouter } from '@daangn/webview-bridge-modern/lib/plugins/Router'
import { PluginShare } from '@daangn/webview-bridge-modern/lib/plugins/Share'

export const bridge = new Bridge().addPlugin(PluginInfo).addPlugin(PluginShare).addPlugin(PluginRouter)

export const IS_WEB = bridge.environment === 'Web'
